# Creating International footer based from Backbone View.
# This is shown only for UK that too in third step only.
Backbone = require 'backbone'
Backbone.$ = $
SharedFooterIntlPhoneNumberView = require('./phone_number_view')

class SharedFooterIntlMainView extends Backbone.View
  class: 'box support-footer'
  id: 'intl_footer'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.shared'
    @template = @options.template
    @emailFormModel = @options.model

  renderPhoneNumberView: ->
    propagateEventBeforeReplacingElements( () =>
      phoneNumberView = new SharedFooterIntlPhoneNumberView({
        emailFormModel: @emailFormModel
        renderPopup: true
      })
      phoneNumberView.render()
    )

  renderEmailForm: ->
    @options.emailUs()

  render: ->
    @$el.append toHtml(@template, @toHash() , @I18nScope)

  toHash: ->
    window.getOrderInfoForBH(Groupon.Support.currentOrder)

  events :
    "click span.lnk-call-us"  : "renderPhoneNumberView"
    "click span.lnk-email-us"  : "renderEmailForm"

module.exports = SharedFooterIntlMainView
